import {
  AddCircle,
  BorderColor,
  Description,
  Visibility,
  Search,
  Print,
} from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Box,
  Chip,
  Typography,
  Grid,
  TextField,
  MenuItem,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import useApi from "_api/index";
import Actions from "components/Car/Actions";
import TableData from "components/Car/Table";
import { GradientButton } from "components/GradientButton";
import { GradientButtonOutline } from "components/GradientButton";
import ModalConsignmentCar from "components/Modal/Car/ModalConsignmentCar";
import ModalDetailCar from "components/Modal/Car/ModalDetailCar";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SaveIcon from "@mui/icons-material/Save";
import api from "_api";
import { useAuth } from "hooks/useAuth";
import CustomizeDatePicker from "components/DatePicker";
import CustomPagination from "components/TableExplanded/Pagination";
import { formatDateMonthYear, formatDateTime } from "utils/helpers/format";
import { getStatusColor } from "utils/helpers/statusColors";
import ChipCustomize from "components/Chip";

const currencies = [
  {
    value: "",
    label: "",
  },
  {
    value: "ซื้อ",
    label: "ซื้อ",
  },
  {
    value: "ขาย",
    label: "ขาย",
  },
  // {
  //   value: 'BTC',
  //   label: '฿',
  // },
  // {
  //   value: 'JPY',
  //   label: '¥',
  // },
];

const typeMap = {
  consignment: "ฝากขาย",
  pawn: "ขายฝาก",
  sell: "ขาย",
  buy: "ซื้อ",
};

const ListByCustomerCar = () => {
  const { user } = useAuth();
  const [loading, setLoading] = React.useState(false);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = React.useState(false);
  const [selectedCar, setSelectedCar] = useState(null);
  const [listByCustomerCar, setListByCustomerCar] = useState([]);
  // const [errorMsg, setErrorMsg] = useState(null);
  // const [errorOpen, setErrorOpen] = useState(false);
  const [carCode, setCarCode] = useState("");
  const [cusName, setCusName] = useState("");
  const [idCard, setIdCard] = useState("");
  // const [type, setType] = useState("");
  const [searchDate, setSearchDate] = useState("");
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 1,
  });

  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, [pagination.page, pagination.limit]);

  const handlePageChange = (event, value) => {
    setPagination((prev) => ({
      ...prev,
      page: value + 1,
    }));
  };
  const handleRowsPerPageChange = (event) => {
    setPagination((prev) => ({
      ...prev,
      limit: event.target.value,
      page: 1, // Reset to first page when changing rows per page
    }));
  };

  const fetchData = async (isClear = false) => {
    // console.log("call fetchData");
    setLoading(true);
    try {
      const response = await useApi.list_by_customer_car.getListByCustomerCar({
        page: pagination.page,
        limit: pagination.limit,
        ...(!isClear && {
          searchName: cusName ?? "",
          searchIdcard: idCard ?? "",
          search: carCode ?? "",
          searchDate: searchDate ?? "",
        }),
      });
      // console.log({ response });
      if (response.success) {
        const { data, meta } = response;
        // console.log("data : ",data);

        // แปลง array ของ item (ซ้อน) => เป็นแถวสำหรับ TableData
        const rows = (data ?? []).map((it) => ({
          // --- ฟิลด์บนหัวตาราง / ที่ใช้ทั่วไป ---
          order_id: it.order_id ?? null,
          order_code: it.order_code ?? "-",
          created_at: it.created_at ?? null,
          status_name: it.status_name ?? "-",
          car_price: it.car?.car_price,
          customer_idcard: it.customer?.customer_idcard ?? "-",
          customer_name: it.customer?.customer_name ?? "-",
          order_type: typeMap[it.order_type] ?? "-",

          // --- ฟิลด์สำหรับแถวขยาย (ต้องเป็น TOP-LEVEL ให้ตรง subColumns) ---
          car_code: it.car?.car_code ?? "-",
          license_plate: it.car?.license_plate ?? "-",
          car_brand: it.car?.car_brand ?? "ไม่มีข้อมูล",
          car_model: it.car?.car_model ?? "ไม่มีข้อมูล",
          car_type: it.car?.car_type || "ไม่มีข้อมูล",

          // --- เก็บ nested object เผื่อคอมโพเนนต์อื่นอ้าง row.car.xxx / row.customer.xxx ---
          customer: {
            customer_name: it.customer?.customer_name ?? "-",
            customer_idcard: it.customer?.customer_idcard ?? "-",
            customer_phonenumber: it.customer?.customer_phonenumber ?? "-",
          },
          car: {
            car_id: it.car?.car_id ?? null,
            car_code: it.car?.car_code ?? "-",
            license_plate: it.car?.license_plate ?? "-",
            car_brand: it.car?.car_brand ?? "ไม่มีข้อมูล",
            car_model: it.car?.car_model ?? "ไม่มีข้อมูล",
            car_type: it.car?.car_type || "ไม่มีข้อมูล",
          },

          car_pictures: it.car?.car_picture ?? null,
          _raw: it,
        }));
        setListByCustomerCar(rows);

        setPagination({
          page: meta.page || 1,
          limit: meta.limit || 10,
          total: meta.total || 0,
          totalPages: meta.totalPages || 1,
        });
      } else {
        // setErrorMsg(response?.message || "โหลดข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง");
        // setErrorOpen(true);
      }
    } catch (error) {
      console.error("Error fetching list by customer cars:", error);
      // setErrorMsg("โหลดข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง");
      // setErrorOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setIsDetailModalOpen(false);
    setSelectedCar(null);
  };

  const handleExportExcel = async () => {
    await api.product
      .exportExcelListOrderByCustomer(user?.company_id)
      .then((res) => {
        const contentDisposition = res.headers["content-disposition"];
        let filename = "download.xlsx"; // Default กรณีไม่มีชื่อไฟล์จาก API

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?(.+?)"?$/);
          if (match && match[1]) {
            filename = match[1];
          }
        }

        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.error("Error exporting excel:", error);
      });
  };

  const handleClearSearch = async () => {
    setCarCode("");
    setCusName("");
    setIdCard("");
    setSearchDate("");
    fetchData();

    // setType("");
    // if (pagination.page !== 1) {
    //   setPagination((prev) => ({
    //     ...prev,
    //     page: 1, // Reset to first page when clearing search
    //   }));
    // } else {
    //   fetchData(true);
    // }
  };

  const handleSearch = () => {
    if (carCode || cusName || idCard || searchDate) {
      if (pagination.page !== 1) {
        setPagination((prev) => ({
          ...prev,
          page: 1, // Reset to first page when searching
        }));
      } else {
        fetchData();
      }
    }
  };

  const DeleteOrder = async (values) => {
    console.log("order_id : ", values);
    try {
      const chageStatusOrder = await useApi.list_by_customer_car.deleteOrder(
        values
      );
      if (chageStatusOrder) fetchData();
    } catch (error) {
      console.error("Error DeleteOrder data:", error);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography component={"div"} sx={{ fontSize: "32px" }}>
          รายการแยกตามชื่อลูกค้า
        </Typography>
        <Grid display={"flex"} style={{ gap: "8px" }}>
          <GradientButtonOutline
            onClick={handleExportExcel}
            sx={{
              px: 3,
              display: "flex",
              alignItems: "center",
              height: "48px",
            }}
          >
            <Typography style={{ marginRight: "8px" }}>ส่งออก Excel</Typography>
            <SaveIcon fontSize="medium" />
          </GradientButtonOutline>
        </Grid>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 2,
          mb: 2,
        }}
      >
        {/* กลุ่ม รหัสรายการ */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 2,
            flex: 1, // ✅ ให้กรุ๊ปนี้ขยายได้
            minWidth: 0, // ✅ กัน overflow/ให้ลูกยืด-หดได้
          }}
        >
          <Typography sx={{ fontSize: "16px", whiteSpace: "nowrap" }}>
            รหัสรายการ:
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="ค้นหา"
            sx={{
              flex: 1, // ✅ ให้ช่องยืดเต็มกรุ๊ป
              "& .MuiOutlinedInput-root": { bgcolor: "white", height: 40 },
            }}
            value={carCode}
            onChange={(e) => setCarCode(e.target.value)}
          />
        </Box>

        {/* กลุ่ม วันที่ */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 2,
            flex: 1, // ✅ ให้กรุ๊ปนี้ขยายได้เท่าๆกัน
            minWidth: 0,
          }}
        >
          <Typography
            sx={{
              fontSize: "16px",
              whiteSpace: "nowrap",
            }}
          >
            วันที่:
          </Typography>
          <CustomizeDatePicker
            value={searchDate}
            onChange={(date) => {
              setSearchDate(date);
            }}
            disableFuture={true}
          />
        </Box>

        {/* กลุ่ม ชื่อลูกค้า */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 2,
            flex: 1, // ✅ ให้กรุ๊ปนี้ขยายได้เท่าๆกัน
            minWidth: 0,
          }}
        >
          <Typography sx={{ fontSize: "16px", whiteSpace: "nowrap" }}>
            ชื่อลูกค้า:
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="ค้นหา"
            sx={{
              flex: 1, // ✅ ให้ช่องยืดเต็มกรุ๊ป
              "& .MuiOutlinedInput-root": { bgcolor: "white", height: 40 },
            }}
            value={cusName}
            onChange={(e) => setCusName(e.target.value)}
          />
        </Box>

        {/* กลุ่ม เลขบัตรประชาชน */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 2,
            flex: 1, // ✅ ให้กรุ๊ปนี้ขยายได้เท่าๆกัน
            minWidth: 0,
          }}
        >
          <Typography sx={{ fontSize: "16px", whiteSpace: "nowrap" }}>
            เลขบัตรประชาชน:
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="ค้นหา"
            sx={{
              flex: 1, // ✅ ให้ช่องยืดเต็มกรุ๊ป
              "& .MuiOutlinedInput-root": { bgcolor: "white", height: 40 },
            }}
            value={idCard}
            onChange={(e) => setIdCard(e.target.value)}
          />
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 2,
          mb: 2,
          justifyContent: "flex-end",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 2,
            alignItems: "center",
          }}
        >
          <GradientButtonOutline
            onClick={() => {
              // Handle clear action
              handleClearSearch();
            }}
            sx={{
              height: "40px",
            }}
          >
            ล้าง
          </GradientButtonOutline>
          <GradientButton
            onClick={() => {
              // Handle search action
              handleSearch();
            }}
            endIcon={<Search />}
          >
            ค้นหา
          </GradientButton>
        </Box>
      </Box>

      <TableData
        loading={loading}
        data={listByCustomerCar}
        columns={[
          { key: "expand", label: "" },
          {
            key: "car_pictures",
            label: "รูปภาพ",
          },
          { key: "order_code", label: "รหัสรายการ" },
          { key: "customer_idcard", label: "เลขบัตรประชาชน" },
          { key: "customer_name", label: "ชื่อ-สกุล" },
          { key: "car_price", label: "จำนวนเงิน" },
          {
            key: "created_at",
            label: "วันที่ทำรายการ",
            style: {
              textAlign: "left",
              whiteSpace: "pre-line",
            },
            render: (row) => {
              return row.created_at ? (
                <Typography sx={{ whiteSpace: "pre-line" }}>
                  {formatDateTime(row.created_at)}
                </Typography>
              ) : (
                "-"
              );
            },
          },
          {
            key: "status_name",
            label: "สถานะ",
            render: (row) => {
              return (
                <ChipCustomize
                  label={row.status_name}
                  status={row.status_name}
                />
              );
            },
          },
          {
            key: "order_type",
            label: "ประเภท",
            render: (row) => {
              return (
                <ChipCustomize label={row.order_type} status={row.order_type} />
              );
            },
          },
          {
            key: "action",
            label: "",
            style: {
              textAlign: "right",
            },
            render: (row) => (
              <Actions
                menuList={[
                  {
                    label: "ดูรายละเอียด",
                    icon: <Visibility />,
                    onClick: () => {
                      // Handle view details action
                      setSelectedCar(row);
                      setIsDetailModalOpen(true);
                      console.log("View details for", row);
                    },
                  },
                  {
                    label: "พิมพ์",
                    icon: <Print />,
                    onClick: () => {},
                  },
                  ...(row.status_name === "ขายแล้ว"
                    ? []
                    : [
                        {
                          label: "ย้ายไปถังขยะ",
                          icon: <DeleteIcon />,
                          onClick: () => {
                            // handleMenuClose();
                            DeleteOrder(row.order_id);
                          },
                        },
                      ]),
                ]}
              />
            ),
          },
        ]}
      />

      <CustomPagination
        totalPage={pagination.totalPages}
        onPageChange={(event, value) => {
          handlePageChange(event, value);
        }}
        page={pagination.page - 1}
        rowsPerPage={pagination.limit}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      <ModalDetailCar
        open={isDetailModalOpen}
        onClose={handleCloseModal}
        rowID={selectedCar ? selectedCar.car.car_id : null}
        type="list_by_customer_car"
      />
    </Box>
  );
};

export default ListByCustomerCar;
